var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"side-cards"},_vm._l((_vm.cards),function(item){return _c('SideCard',_vm._b({key:item.key,staticClass:"item",on:{"sub-window":function($event){return _vm.$emit('sub-window', $event)}}},'SideCard',item,false))}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }